import 'normalize.css'
import 'react-modal-video/scss/modal-video.scss'
import './src/styles/global.sass'
